import React, {Component} from 'react';
import {Row, Col} from "react-bootstrap";
import PokazCenyZeZnizkamiSearchbox from "./components/PokazCenyZeZnizkamiSearchbox";
import ClientService from "../../biletyApi/ClientService";
import PokazTabeleCenIZnizek from "./components/PokazTabeleCenIZnizek";
import TopIf from "../../../../../componentsTopsa/if/TopIf";
import ZnizkiService from "../../znizki/ZnizkiService";

export default class PokazCenyZeZnizkami extends Component {
    constructor(props) {
        super(props);
        this.state = {
            jednorazowe:[],
            miesieczne:[],
            czyBylPrzycisk:false,
        }
        this.onClickPokaz = this.onClickPokaz.bind(this)
        this.onWyczysc = this.onWyczysc.bind(this)
    };

    onClickPokaz(trasa,mod,mdo,data,kurs){
        this.setState({jednorazowe:[], miesieczne:[],czyBylPrzycisk:false})
        this.szukajJednorazowychZnizek(kurs,mod,mdo)
        this.szukajMiesiecznychZnizek(data,mod,mdo,trasa)
    }

    szukajJednorazowychZnizek(kurs,mod,mdo){
        let obj = {
            "idKu": kurs.idKu,
            "idMiDo": mdo.idMi,
            "idMiOd": mod.idMi
        }
        ZnizkiService.getWszytskieZnizkiJednorazowe(obj).then(function (response) {
            this.setState({jednorazowe:response.data,czyBylPrzycisk:true})
        }.bind(this))
    }

    szukajMiesiecznychZnizek(data,mod,mdo,trasa){
        let obj = {
            "data": data,
            "idMiDo": mdo.idMi,
            "idMiOd": mod.idMi,
            "idTr": trasa.idTr,
            "kierunek": 2,
            "okres": "M1",
            "uoperatora":null
        }
        ZnizkiService.getWszytskieZnizkiMiesieczne(obj).then(function (response) {
            this.setState({miesieczne:response.data})
        }.bind(this))
    }

    onWyczysc(){
        this.setState({
            jednorazowe:[],
            miesieczne:[],
            czyBylPrzycisk:false,
        })
    }

    render() {

        return (
            <Row>
               <Col xs={12}>
                    <PokazCenyZeZnizkamiSearchbox trasy={this.props.trasy} handleClickPokaz={this.onClickPokaz} handleWyczyscSzukanie={this.onWyczysc}/>
               </Col>
                <TopIf isTrue={this.state.czyBylPrzycisk}>
                <Col xs={12}>
                    <Row>
                        <Col xs={12} lg={6}>
                            <PokazTabeleCenIZnizek data={this.state.jednorazowe} czyJednorazowe={true}/>
                        </Col>
                        <Col xs={12} lg={6}>
                            <PokazTabeleCenIZnizek data={this.state.miesieczne} czyJednorazowe={false}/>
                        </Col>
                    </Row>
                </Col>
                </TopIf>
            </Row>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/konfiguracja/biletyConfig/cenyBiletow/pokażCenyZeZnizkami/PokazCenyZeZnizkami.js